import { parseCookie } from './utils.ts'

export const getGaryBasicAuthHeaders = ({
  apiKey,
  apiSecret,
}: {
  apiKey: string
  apiSecret: string
}): Record<string, string> => {
  const credentials = btoa(`${apiKey}:${apiSecret}`)

  return {
    'Content-Type': 'application/json',
    Authorization: `Basic ${credentials}`,
  }
}

export const getGarySessionCookieHeader = ({
  cookie,
  sessionCookieKey,
}: {
  cookie: string | null
  sessionCookieKey: string
}) => {
  if (!cookie) {
    return null
  }

  const sessionCookieValue = parseCookie(cookie, sessionCookieKey)

  if (!sessionCookieValue) {
    return null
  }

  return `${sessionCookieKey}=${sessionCookieValue}`
}

export const getGarySessionCookieHeaders = ({
  cookie,
  sessionCookieKey,
}: {
  cookie: string | null
  sessionCookieKey: string
}): Record<string, string> | null => {
  const sessionCookieHeader = getGarySessionCookieHeader({
    cookie,
    sessionCookieKey,
  })

  if (!sessionCookieHeader) {
    return null
  }

  return {
    'Content-Type': 'application/json',
    Cookie: sessionCookieHeader,
  }
}
